export default __webpack_public_path__ + "static/media/mode-41.14fee08c.svg";